import { apiClient } from '@/lib/axios'

/**
 * Get current user information
 */
export const getUserInfo = async () => {
  return await apiClient.get('/user')
}

/**
 * Generate a new secret key for user API access
 */
export const updateUserSecretKey = async () => {
  return await apiClient.get('/updateUserSecretKey')
}

/**
 * Update user email with confirmation code
 */
export const updateEmail = async (params: { email: string; confirmation_code: number }) => {
  return await apiClient.post('/updateEmail', params)
}

/**
 * Get account overview for authenticated user
 */
export const getAccountOverview = async (params?: { coin?: string }) => {
  return apiClient.post('/accountOverview', params || {})
}

/**
 * Get list of user's workers
 */
export const getWorkers = async (params?: { coin?: string }) => {
  return apiClient.post('/workers', params || {})
}

/**
 * Get worker overview for authenticated user
 */
export const getWorkerOverview = async (params: { worker: string; coin?: string }) => {
  return apiClient.post('/workerOverview', params)
}

/**
 * Get worker hashrate for authenticated user
 */
export const getWorkerHashrate = async (params?: {
  page?: number
  limit?: number
  coin?: string
  sort_field?: string
  sort_order?: string
}) => {
  return apiClient.post('/workerHashrate', params || {})
}

/**
 * Get account hashrate history for authenticated user
 */
export const getAccountHashrateHistory = async (params?: {
  start_date?: string
  end_date?: string
  page?: number
  limit?: number
  coin?: string
  sort_field?: string
  sort_order?: string
}) => {
  return apiClient.post('/accountHashrateHistory', params || {})
}

/**
 * Get account hashrate chart for authenticated user
 */
export const getAccountHashrateChart = async (params: {
  chart_type: 1 | 2 | 3 | 4 | 5 // 1: hourly, 2: daily, 3: hourly 7 days, 4: daily month, 5: daily year
  period?: number
  coin?: string
}) => {
  return apiClient.post('/accountHashrateChart', params)
}

/**
 * Get worker hashrate history for authenticated user
 */
export const getWorkerHashrateHistory = async (params: {
  worker: string
  chart_type: 1 | 2 | 3 | 4 | 5
  period?: number
  coin?: string
}) => {
  return apiClient.post('/workerHashrateHistory', params)
}

/**
 * Get reward history for authenticated user
 */
export const getRewardHistory = async (params?: {
  start_date?: string
  end_date?: string
  range?: 'week' | 'month' | 'year'
  page?: number
  limit?: number
  coin?: string
  sort_field?: string
  sort_order?: string
  worker?: string
}) => {
  return apiClient.post('/rewardHistory', params || {})
}

/**
 * Change user password (with reset token)
 * Used for password reset flow
 */
export const updatePassword = async (params: {
  user_id: number
  token: string
  password: string
}) => {
  return apiClient.post('/updatePassword', params)
}

/**
 * Get workers stats for authenticated user with filters and search
 */
export const getWorkersStats = async (params?: {
  page?: number
  limit?: number
  coin?: string
  status?: string
  search?: string
  sort_field?: string
  sort_order?: string
}) => {
  return apiClient.post('/workersStats', params || {})
}
